import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=b38ce31c&"
import script from "./UsersList.vue?vue&type=script&lang=js&"
export * from "./UsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b38ce31c')) {
      api.createRecord('b38ce31c', component.options)
    } else {
      api.reload('b38ce31c', component.options)
    }
    module.hot.accept("./UsersList.vue?vue&type=template&id=b38ce31c&", function () {
      api.rerender('b38ce31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/UsersList.vue"
export default component.exports